import axios, { type AxiosInstance, type InternalAxiosRequestConfig } from 'axios';

import { env } from './runtime-env';
import { useAuthStore } from '../stores/useAuthStore';

export const apiClient: AxiosInstance = axios.create({
  baseURL: env.apiUrl,
  withCredentials: true,
  timeout: 30_000,
  headers: { 'Content-Type': 'application/json' },
});

apiClient.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  const token = useAuthStore.getState().accessToken;
  if (token) {
    config.headers.set('Authorization', `Bearer ${token}`);
  }
  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  (error: unknown) => {
    if (axios.isAxiosError(error) && error.response?.status === 401) {
      useAuthStore.getState().logout();
      if (typeof window !== 'undefined' && !window.location.pathname.startsWith('/login')) {
        window.location.href = `/login?from=${encodeURIComponent(window.location.pathname)}`;
      }
    }
    return Promise.reject(error);
  },
);

/**
 * Client para endpoints PÚBLICOS (sem auth) — link público de proposta, checkout.
 * Sem header Authorization e sem o interceptor de 401→logout (um 404/410 num link
 * público não deve deslogar nem redirecionar o usuário). Mesma baseURL do principal.
 */
export const publicApiClient: AxiosInstance = axios.create({
  baseURL: env.apiUrl,
  withCredentials: false,
  timeout: 30_000,
  headers: { 'Content-Type': 'application/json' },
});
